import { CreditRegisterModule } from './credit-register/credit-register.module';
import { RegisterConfirmationModule } from './register-confirmation/register-confirmation.module';
import { NgModule } from "@angular/core";
import { CharacteristicConsultModule } from './characteristic-consult/characteristic-consult.module';

@NgModule({
  imports: [
    RegisterConfirmationModule,
    CreditRegisterModule,
    CharacteristicConsultModule
  ]
})
export class RegisterModule {}
